import { useState } from 'react';

export type Query = {
  offset: number;
  limit: number;
  search: string;
  [key: string]: any;
};

export const useTableFilters = (
  initialQuery: Query = {
    offset: 0,
    limit: 25,
    search: '',
  }
) => {
  const [query, setQuery] = useState(initialQuery);
  const [searchValue, setSearchValue] = useState('');
  const [itemOrder, setItemOrder] = useState('');
  const [order, setOrder] = useState(false);

  const handleLimitChange = (limit: number) => {
    setQuery(prev => ({ ...prev, limit }));
  };

  const handleOrder = (key: string) => {
    setOrder(!order);
    setItemOrder(key);
    setQuery(prev => ({ ...prev, ordering: `${order ? '-' : ''}${key}` }));
  };

  const handlePageChange = (page: number) => {
    setQuery(prev => ({ ...prev, offset: page * query.limit }));
  };

  const handleSearch = (search: string = searchValue) => {
    if (search.trim().length >= 3) {
      setQuery(prev => ({ ...prev, offset: 0, search }));
    } else {
      setQuery(prev => ({ ...prev, offset: 0, search: '' }));
    }
  };

  return {
    itemOrder,
    query,
    searchValue,
    setItemOrder,
    setQuery,
    setSearchValue,
    handleLimitChange,
    handleOrder,
    handlePageChange,
    handleSearch,
  };
};
